<template>
    <div id="overlay">
        <div class="dialog-wrap">
            <div class='input-player-dialog-top' ref="defaultScrollTop">
                <div>
                    <span class="input-player-close-btn" @click="CloseEvent">×</span>
                </div>
                <div>
                    <div class='dialog_title'>プロフィール編集</div>
                    <div class="p-4">
                        <div class="container bg-white">
                            <div class="row py-1">
                                <div class="col-sm-3">お名前</div>
                                <div class="col-sm d-sm-flex">
                                    <input class="form-control col-sm-5 mb-1 mr-1" type='text' v-model="membersInfo.family_name" :disabled="memberReadonlyFlag">
                                    <!-- <input class="form-control col-sm-5" type='text' v-model="membersInfo.given_name" :disabled="memberReadonlyFlag"> -->
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">ニックネーム</div>
                                <div class="col-sm">
                                    <input class="form-control col-sm-5 mb-1 mr-1" type='text' v-model="membersInfo.nickname">
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">性別</div>
                                <div class="col-sm">
                                    男<input type='radio' name='gender' style='margin-left: 20px; margin-right: 60px;' v-model="membersInfo.gender" value="0" :disabled="memberGenderReadonlyFlag" checked>
                                    女<input type='radio' name='gender' style='margin-left: 20px; margin-right: 20px;' v-model="membersInfo.gender" value="1" :disabled="memberGenderReadonlyFlag">
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">年代</div>
                                <!-- <div class="col-sm-3">
                                    <input class="form-control" type='text' v-model="membersInfo.era" :disabled="noMemberReadonlyFlag">
                                </div> -->
                                <div class="col-sm-3">
                                    <select v-model="membersInfo.era" class="form-control" :disabled="noMemberReadonlyFlag">
                                        <option v-for="option in eraSelect" v-bind:value="option.value" :key="option.text">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">スコアレベル</div>
                                <!-- <div class="col-sm-3">
                                    <input class="form-control" type='text' v-model="membersInfo.score_level" :disabled="noMemberReadonlyFlag">
                                </div> -->
                                <div class="col-sm-3">
                                    <select v-model="membersInfo.score_level" class="form-control" :disabled="noMemberReadonlyFlag">
                                        <option v-for="option in scoreLevelSelect" v-bind:value="option.value" :key="option.text">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">プロフィール</div>
                                <div class="col-sm">
                                    <textarea class='form-control input-player-player-textareas' v-model="membersInfo.profile" :disabled="noMemberReadonlyFlag"></textarea>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-sm-3">意気込み</div>
                                <div class="col-sm">
                                    <textarea class='form-control input-player-player-textareas' v-model="membersInfo.enthusiasm" :disabled="noMemberReadonlyFlag"></textarea>
                                </div>
                            </div>
                            <div class="row py-3">
                                <button
                                    class='bluebackbutton dialogBtn'
                                    v-on:click="ClickEvent">
                                    登&nbsp;&nbsp;録
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_FRIEND_PROFILE } from '../../../constants/golf_friend'

export default {
    components: {
    },
    data () {
        return {
            memberReadonlyFlag: false,
            noMemberReadonlyFlag: false,
            memberGenderReadonlyFlag: false,
            member_no: null,
            membersInfo: {
                email: null,
                family_name: null,
                given_name: null,
                nickname: null,
                era: null,
                gender: 0,
                score_level: null,
                enthusiasm: null,
                profile: null,
                player_no: null
            },
            email: null,
            family_name: null,
            given_name: null,
            era: null,
            gender: 0,
            score_level: null,
            enthusiasm: null,
            profile: null,
            playerId: null,
            startFrameId: null,
            wording_type: null,
            wording_type_second: null,
            FriendPlayerInfo: {},
            loadingCount: 0,
            // 年代セレクトボックスの中身
            eraSelect: [
                { text: '', value: '' },
                { text: '10代以下', value:"0" },
                { text: '10代', value:"10" },
                { text: '20代', value:"20" },
                { text: '30代', value:"30" },
                { text: '40代', value:"40" },
                { text: '50代', value:"50" },
                { text: '60代', value:"60" },
                { text: '70代', value:"70" },
                { text: '80代', value:"80" },
                { text: '90代', value:"90" },
                { text: '100代', value:"100" }
            ],
            // スコアレベルセレクトボックスの中身
            scoreLevelSelect: [
                { text: '', value: '' },
                { text: '60台', value:"60" },
                { text: '70台', value:"70" },
                { text: '80台', value:"80" },
                { text: '90台', value:"90" },
                { text: '100台', value:"100" },
                { text: '110台', value:"110" },
                { text: '120台', value:"120" },
                { text: '130台', value:"130" },
                { text: '140台', value:"140" },
                { text: '150台以上', value:"150" },
            ],
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
        },
        async Open(playerInfo){
            this.loadingOn();
            this.membersInfo.member_no = playerInfo.member_no;
            this.membersInfo.email = (playerInfo.email != null) ? playerInfo.email.trim() : playerInfo.email;
            this.membersInfo.mobile_number = (playerInfo.mobile_number != null) ? playerInfo.mobile_number.trim() : playerInfo.mobile_number;
            this.membersInfo.family_name = (playerInfo.family_name != null) ? playerInfo.family_name.trim() : playerInfo.family_name;
            this.membersInfo.given_name = (playerInfo.given_name != null) ? playerInfo.given_name.trim() : playerInfo.given_name;
            this.membersInfo.nickname = playerInfo.nickname;
            this.membersInfo.era = playerInfo.era;
            this.membersInfo.score_level = playerInfo.score_level;
            this.membersInfo.profile = playerInfo.profile;
            this.membersInfo.enthusiasm = playerInfo.enthusiasm;
            this.membersInfo.player_no = playerInfo.player_no;
            this.playerId = playerInfo.id;
            this.startFrameId = playerInfo.startFrameId;
            if (playerInfo.gender == null || playerInfo.gender == 0) {
                this.membersInfo.gender = 0;
            } else {
                this.membersInfo.gender = playerInfo.gender;
            }
            // 会員だったら
            if (playerInfo.member_no && playerInfo.selectFlag == true) {
                this.memberReadonlyFlag = true;
                this.memberGenderReadonlyFlag = true;
                this.GetFriendProfile(this.membersInfo.email);
            // 友達選択されて会員では無かったら
            } else if (playerInfo.member_no == null && playerInfo.selectFlag == true) {
                this.memberReadonlyFlag = true;
                this.memberGenderReadonlyFlag = false;
                this.GetFriendProfile(this.email);
            // 親画面で入力されていなかったら
            } else if (this.email == null || this.email.length <= 0 &&
                this.family_name == null || this.family_name.length <= 0 &&
                this.given_name.email == null || this.given_name.length <= 0 &&
                playerInfo.selectFlag === null || playerInfo.selectFlag === false) {
                this.memberReadonlyFlag = false;
                this.memberGenderReadonlyFlag = false;
            }
            this.loadingOff();

        },
        /** ----------------------------------------------
         * ✖ボタン押下
         * ---------------------------------------------- */
        CloseEvent () {
            this.$emit('close-dialog');
        },
        /** ----------------------------------------------
         * 登録ボタン押下
         * ---------------------------------------------- */
        ClickEvent (){
            this.FriendPlayerInfo.member_no = this.membersInfo.member_no;
            this.FriendPlayerInfo.email = this.membersInfo.email;
            this.FriendPlayerInfo.mobile_number = this.membersInfo.mobile_number;
            this.FriendPlayerInfo.gender = this.membersInfo.gender;
            this.FriendPlayerInfo.family_name = this.membersInfo.family_name;
            this.FriendPlayerInfo.given_name = this.membersInfo.given_name;
            this.FriendPlayerInfo.nickname = this.membersInfo.nickname;
            this.FriendPlayerInfo.era = this.membersInfo.era;
            this.FriendPlayerInfo.score_level = this.membersInfo.score_level;
            this.FriendPlayerInfo.profile = this.membersInfo.profile;
            this.FriendPlayerInfo.enthusiasm = this.membersInfo.enthusiasm;
            this.FriendPlayerInfo.id = this.playerId;
            this.FriendPlayerInfo.startFrameId = this.startFrameId;
            this.FriendPlayerInfo.player_no = this.membersInfo.player_no;
            this.$emit('from-Dialog', this.FriendPlayerInfo);
            // 入力情報初期化
            this.FriendPlayerInfo = {};
            this.membersInfo.email = null;
            this.membersInfo.mobile_number = null;
            this.membersInfo.family_name = null;
            this.membersInfo.given_name = null;
            this.membersInfo.nickname = null;
            this.membersInfo.era = null;
            this.membersInfo.score_level = null;
            this.membersInfo.profile = null
            this.membersInfo.gender = null;
            this.membersInfo.enthusiasm = null;
            this.membersInfo.player_no = null;
        },
        /** ----------------------------------------------
         * プロフィール取得
         * @email 検索する時のメールアドレス
         * ---------------------------------------------- */
        GetFriendProfile(email){
            this.loadingOn();
            this.$apollo.mutate({
                mutation: GET_FRIEND_PROFILE,
                variables: {
                    email: email,
                }
            }).then(res => {
                var profile = res.data.getFriendProfile.Friend;
                this.membersInfo.family_name = profile[0].family_name;
                this.membersInfo.given_name = profile[0].given_name;
                this.membersInfo.nickname = profile[0].nickname
                this.membersInfo.era = profile[0].era;
                this.membersInfo.score_level = profile[0].score_level;
                this.membersInfo.profile = profile[0].profile;
                this.membersInfo.gender = profile[0].gender;
                this.membersInfo.member_no = profile[0].member_no;
                this.loadingOff();
            }).catch(error => {
                this.error = error;
                this.loadingOff();
            });
        },
        /** ----------------------------------
         * モーダル内のスクロール位置リセット処理
         * ----------------------------------- */
        scrollChange () {
            this.$refs.defaultScrollTop.scrollTop = 0;
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function (){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function (){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        }
    }
}

</script>

<style scoped>
.container{
    height: auto;
}
</style>
